module.exports = __webpack_public_path__ + "media/images/icons/icon-product_2-6ef561a835276aca3e264574b5c07a5e.svg";